import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Dictionary, keyBy } from 'lodash';
import { RootState } from 'cityads-v3/types/reducer'
import { useEntities } from 'cityads-v3/hooks/entities';
import { useOfferTags } from 'cityads-v3/hooks/offers';
import { useTrafficTypesEntitiesWithRestrictions } from 'cityads-v3/hooks/trafficTypes';
import { SubscriptionStatusList } from 'cityads-v3/types/subscriptionStatus';

import {
  ACTION_TYPE_DIRECTION_ID_MOBILE,
} from 'cityads-v3/reducers/offers';
import { ToolList } from 'cityads-v3/types/tools';
import { ActionTypeDirection } from 'cityads-v3/types/offers';

export function useFilterLists() {
  const [offerTags, offerTagsByCode] = useOfferTags();
  const trafficTypeList = keyBy(useTrafficTypesEntitiesWithRestrictions(null)[0], 'id')
  const subscriptionStatusList = keyBy(useEntities<SubscriptionStatusList>('subscriptionStatuses')[0]?.subscriptionStatus, 'id')
  const toolList = keyBy(useEntities<ToolList>('tools')[0]?.tool, 'id')

  return {
    offerTags,
    offerTagsByCode,
    regionList: useSelector((state: RootState) => state.offers.regionsById),
    directionAndPlatformList: useDirectionAndPlatformList(),
    subscriptionStatusList,
    categoryList: useSelector((state: RootState) => state.offers.categoriesById),
    trafficTypeList,
    toolList,
  }
}

type ActionTypeDirectionWithParents = ActionTypeDirection & {
  parent: ActionTypeDirection
  parents: ActionTypeDirection[]
}

export function useDirectionAndPlatformList() {
  const actionTypeDirections = useSelector((state: RootState) => state.offers.action_type_direction)
  const actionTypeDirectionsById = useSelector((state: RootState) => state.offers.action_type_directionById)
  const platforms = useSelector((state: RootState) => state.offers.platform);
  const platformsById = useSelector((state: RootState) => state.offers.platformById);

  return useMemo(() => {
    const itemsById = (
      {
        ...actionTypeDirections.reduce((acc, atdId) => ({
          ...acc,
          [`${atdId}-0`]: {
            ...actionTypeDirectionsById[atdId],
            valueFull: `${atdId}-0`
          }
          ,
        }), {}),
        ...platforms.reduce((acc, plId) => ({
          ...acc,
          [`${ACTION_TYPE_DIRECTION_ID_MOBILE}-${plId}`]: platformsById[plId],
        }), {}),
      }
    ) as Dictionary<ActionTypeDirectionWithParents>;

    Object.keys(itemsById).filter(key => key.split('-')[1] !== '0').forEach(key => {
      const parentId = key.split('-')[0] + '-0';
      itemsById[key].parent = itemsById[parentId]
      itemsById[key].parents = [itemsById[parentId]]
    })

    return itemsById;
  }, [
    actionTypeDirections, actionTypeDirectionsById, platforms, platformsById
  ])

}
